export const AIRPORT_URL = "/airport";
export const BASIS_URL = "/basis";
export const CAR_RENTAL_SERVICE_PROVIDER_URL= "/carRentalServiceProvider";
export const CLIENT_URL = "/client";
export const HOTEL_URL = "/hotel";
export const ROOM_URL = "/room";
export const TOUR_URL = "/tour";
export const TOUR_SERVICE_PROVIDER_URL = "/tourServiceProvider";
export const TRANSFER_SERVICE_PROVIDER_URL = "/transferServiceProvider";